import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "./endpoints";

export const logoutUser = async () => {
  try {
    let accessToken = document.cookie.split('; ').find(row => row.startsWith('accessToken='))?.split('=')[1]
    await axios({
      url: `${BASE_URL}/users/logout/`,
      method: "PUT",
      data: null,
      headers: {
        Authorization: `JWT ${accessToken}`,
      },
    })

    document.cookie = `accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure`;
    window.location.href = "/";
  } catch (error) {
    toast.error("Failed to logout");
  }
};

export function usePreviousPath() {
  const previousPageUrl = document.referrer;
  let previousPath = null;
  if (previousPageUrl) {
    const url = new URL(previousPageUrl);
    previousPath = url.pathname;
  }
  return previousPath;
}

export function showApiErrors(error) {
  if (error.response && error.response.data) {
    const errData = error.response.data;

    // Case 1: Direct field-level errors { field: [messages] } format
    if (!errData.data && !errData.message && typeof errData === "object") {
      let hasFieldErrors = false;
      Object.entries(errData).forEach(([field, messages]) => {
        if (Array.isArray(messages)) {
          hasFieldErrors = true;
          messages.forEach((msg) => {
            toast.error(`${msg}`);
          });
        } else if (typeof messages === "string") {
          hasFieldErrors = true;
          toast.error(`${messages}`);
        }
      });
      if (hasFieldErrors) return;
    }

    // Case 2: Errors are in { data: { field: [messages] } } format
    if (errData.data && typeof errData.data === "object") {
      Object.entries(errData.data).forEach(([field, messages]) => {
        if (Array.isArray(messages)) {
          messages.forEach((msg) => {
            toast.error(`${msg}`);
          });
        } else if (typeof messages === "string") {
          toast.error(`${messages}`);
        }
      });
    } else if (typeof errData.data === "string") {
      toast.error(errData.data);
    } else if (errData.data == null && errData.message) {
      toast.error(errData.message);
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  } else {
    toast.error("Something went wrong. Please try again.");
  }
}

export function handleErrorRedirection(error) {
  if (error.response && error.response.status === 403) {
    window.location.href = "/unauthorized";
  }
}

function formatFieldName(field) {
  return field
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

/**
 * Converts backend role format to display format
 * @param {string} role - The role in backend format (e.g., "warehouse_manager")
 * @returns {string} The role in display format (e.g., "Warehouse Manager")
 * @example
 * formatRoleDisplay("warehouse_manager") // Returns "Warehouse Manager"
 * formatRoleDisplay("admin") // Returns "Admin"
 */
export function formatRoleDisplay(role) {
  if (!role) return "";

  return role.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}
